import { render, staticRenderFns } from "./GlobalStatsNavbar.vue?vue&type=template&id=0cc754a2&"
import script from "./GlobalStatsNavbar.vue?vue&type=script&lang=js&"
export * from "./GlobalStatsNavbar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalStatsNavbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc754a2')) {
      api.createRecord('0cc754a2', component.options)
    } else {
      api.reload('0cc754a2', component.options)
    }
    module.hot.accept("./GlobalStatsNavbar.vue?vue&type=template&id=0cc754a2&", function () {
      api.rerender('0cc754a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/GlobalStatsNavbar.vue"
export default component.exports